import axios from 'axios';
import type { AnnouncementsResponse, AnnouncementType } from './types';

export const getAnnouncements = async (
  type: AnnouncementType,
  page: number,
  searchValue: string,
): Promise<AnnouncementsResponse> => {
  const { data } = await axios.get('/announcement/all', {
    params: {
      stringQuery: searchValue,
      type,
      page: page - 1,
    },
  });
  return data;
};
